import { type KeyboardEventHandler, type RefObject } from 'react'

import {
  SecondaryButton,
  Space,
  TertiaryButton,
  TextField,
} from '@procurify/ui'

import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'

export interface ICreditCardProviderInlineCreateViewProps {
  name: string
  nameInputRef: RefObject<HTMLInputElement>
  isSaving: boolean
  onNameChange: (name: string) => void
  onNameKeyDown: KeyboardEventHandler
  onCreate: () => void
  onCancel: () => void
}

export const CreditCardProviderInlineCreateView = ({
  name,
  nameInputRef,
  isSaving,
  onNameChange,
  onNameKeyDown,
  onCreate,
  onCancel,
}: ICreditCardProviderInlineCreateViewProps) => {
  const intl = useProcurifyIntl()

  return (
    <Space size='small'>
      <TextField
        id='credit-card-provider-new-name'
        inputRef={nameInputRef}
        label={intl.formatMessage(messages.nameLabel)}
        placeholder={intl.formatMessage(messages.namePlaceholder)}
        value={name}
        onChange={(event) => onNameChange(event.target.value)}
        onKeyDown={onNameKeyDown}
        disabled={isSaving}
        fullWidth
        autoFocus
      />
      <Space direction='horizontal' justify='end' align='center'>
        <TertiaryButton type='button' onClick={onCancel}>
          {intl.formatMessage(messages.cancelButton)}
        </TertiaryButton>
        <SecondaryButton
          type='button'
          onClick={onCreate}
          isLoading={isSaving}
          disabled={!name.trim()}
        >
          {intl.formatMessage(messages.createButton)}
        </SecondaryButton>
      </Space>
    </Space>
  )
}

CreditCardProviderInlineCreateView.displayName =
  'CreditCardProviderInlineCreateView'
